import React from 'react';


const footer ={
  container:{
    backgroundColor: '#080045',
    bottom: '0px',
    left: "0px",
    right: "0px",
    marginBottom: '0px',
    height: '106px',
    display: 'flex',
    width: '100%'
  },
  confidence:{
    color: "#FFFFFF",
    fontSize: '19px',
    padding: '40px'
  },
  rights:{
    alignItems: 'flex-end',
    marginLeft: 'auto',
    order: 2,
    fontSize: '16px',
    color: '#B2B0C5',
    padding: '40px'
  }
}

const CampaignFooter = props => {
  return (
    <div style={footer.container}>
      <div style={footer.confidence}>Commercial in Confidence</div>
      <div style={footer.rights}>© 2021 LANDMARKS Pty Ltd. All rights reserved</div>
    </div>
  );
};

export default CampaignFooter;
